var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event)?_c('EventDetails',{attrs:{"one-event":_vm.event,"current-user-id":_vm.currentUserId},on:{"close":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }